import React, { useState } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { useAuth } from '../../contexts/auth';
import { Link } from 'react-router-dom';

const AppProfile: React.FC = () => {
	const [expanded, setExpanded] = useState(false);
	const { signOut, userLogin, userAgencyName } = useAuth();

	function onClickExpand() {
		setExpanded(!expanded);
	}

	return (
		<div className='layout-profile'>
			<button className='p-link layout-profile-link' onClick={onClickExpand}>
				<div>
					<span className='userAgencyName'>{userAgencyName}</span>
				</div>
				<br />
				<span className='username'>{userLogin}</span>
				<i className='pi pi-fw pi-cog' />
			</button>

			<CSSTransition
				classNames='p-toggleable-content'
				timeout={{ enter: 1000, exit: 450 }}
				in={expanded}
				unmountOnExit>
				<ul className={classNames({ 'layout-profile-expanded': expanded })}>
					<li>
						<button className='p-link'>
							<i className='pi pi-fw pi-user' />
							<span>Account</span>
						</button>
					</li>
					<li>
						<button className='p-link'>
							<i className='pi pi-fw pi-inbox' />
							<span>Notifications</span>
							<span className='menuitem-badge'>2</span>
						</button>
					</li>
					<li>
						<Link to='/'>
							<button onClick={signOut} className='p-link'>
								<i className='pi pi-fw pi-sign-out' />
								<span>Logout</span>
							</button>
						</Link>
					</li>
				</ul>
			</CSSTransition>
		</div>
	);
};

export default AppProfile;
